import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  ManageReceiptTemplatesRootParamList,
  ReceiptTemplateFormParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ReceiptTemplateFormScreen } from "./ReceiptTemplateFormScreen";
import React from "react";
import { Receipt } from "@towersystems/roam-common/lib/generated-types";
import { useLazyQuery } from "@apollo/client";
import { QUERY_RECEIPT_TEMPLATE } from "../../common";
import { ReceiptTemplateForm } from "../../components/ReceiptTemplateForm";
import { SelectTemplateStyleScreen } from "./SelectTemplateStyleScreen";

const Stack = createStackHeaderNavigator<ReceiptTemplateFormParamList>();

export type EditReceiptTemplateScreenProps = NativeStackScreenProps<
  ManageReceiptTemplatesRootParamList,
  "EditReceiptTemplateScreen"
>;

export const EditReceiptTemplateScreen = ({
  navigation,
  route,
}: EditReceiptTemplateScreenProps) => {
  const [template, setTemplate] = React.useState<Receipt | undefined>(
    undefined
  );

  const { receiptTemplateId } = route.params;

  const [q] = useLazyQuery<{
    receipt: Receipt;
  }>(QUERY_RECEIPT_TEMPLATE);

  React.useEffect(() => {
    if (receiptTemplateId) {
      q({
        variables: { id: receiptTemplateId },
      })
        .then((result) => {
          if (result.data?.receipt) {
            setTemplate(result.data.receipt);
          } else {
            navigation.goBack();
          }
        })
        .catch(() => {
          navigation.goBack();
        });
    } else {
      navigation.goBack();
    }
  }, [receiptTemplateId]);

  if (!template) {
    return null; // or a loading indicator
  }

  return (
    <ReceiptTemplateForm
      defaultFormValues={{
        id: template.id,
        name: template.name,
        defaultTemplateType: template.defaultTemplateType,
        enabled: template.enabled,
        settings: {
          header: template.settings?.header || "",
          footer: template.settings?.footer || "",
          displayCustomerDetails:
            template.settings?.displayCustomerDetails || false,
          labelTax: template.settings.labelTax || "",
          existingLogoURL: template.settings?.logoURL || "",
        },
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerBackgroundContainerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Stack.Group>
          <Stack.Screen
            name="ReceiptTemplateFormScreen"
            component={ReceiptTemplateFormScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            presentation: "modal",
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <Stack.Screen
            name="SelectTemplateStyleScreen"
            component={SelectTemplateStyleScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ReceiptTemplateForm>
  );
};
